import * as types from './mutations-types'

export default {
  [types.setTaxes] (state, taxes) {
    state.taxes = taxes
  },
  [types.setTax] (state, tax) {
    state.tax = tax
  },
  [types.setFilterTax] (state, obj) {
    state.filterTaxes[obj.key] = obj.value
  },
  [types.clearFilterTax] (state, key) {
    delete state.filterTaxes[key]
  },
  [types.clearFilterTaxes] (state) {
    state.filterTaxes = {}
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/taxes/vuex/mutations.js